<template>
  <a
    v-if="uri"
    :href="uri"
    target="_blank"
    class="button is-primary"
  >
    {{ label }}
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentDirectory: 'directory/current',
    }),
    label() {
      return this.currentDirectory?.record_cta_button_label ?? 'Become a Preferred Partner';
    },
    uri() {
      return this.currentDirectory?.record_cta_button_uri;
    },
  },
};
</script>
